import React from 'react';
import { MSG_SESSIONE_SCADUTA, entraDiNuovo, useSessioneScaduta } from '../utils/sessioneScaduta';
import '../styles/Notifiche.css';

/**
 * L'avviso della sessione scaduta con del lavoro a meta' (utils/sessioneScaduta.js),
 * montato una volta sulla radice, accanto alle notifiche (GuardiaUscita).
 *
 * NON e' una notifica: una notifica d'errore si chiude con la X, e chiusa
 * lascerebbe la persona in una pagina dove ogni richiesta prende 401 e
 * nessuno lo dice piu'. Qui l'unica uscita e' «Entra di nuovo», quando ha
 * finito di copiare quello che le serve. E non copre la pagina: il testo
 * scritto deve restare leggibile e selezionabile sotto.
 */
const SessioneScaduta = () => {
    const scaduta = useSessioneScaduta((s) => s.scaduta);
    if (!scaduta) return null;
    return (
        <div className="rm-messaggio rm-messaggio-errore ntf-sessione" role="alert" data-sessione-scaduta>
            <span>{MSG_SESSIONE_SCADUTA}</span>
            <button type="button" className="rm-btn rm-btn-primario ntf-sessione-entra" onClick={entraDiNuovo}>
                Entra di nuovo
            </button>
        </div>
    );
};

export default SessioneScaduta;
